import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

// 山西定制版页面状态判断
const useSXNU = () => {
  let localtion = useLocation();
  let [isSXNU, setIsSXNU] = useState(false);

  useEffect(() => {
    if (localtion.pathname === '/sxnu') {
      setIsSXNU(true);
      sessionStorage.setItem('isSXNU', true);
    } else if (localtion.pathname === '/') {
      setIsSXNU(false);
      sessionStorage.removeItem('isSXNU');
    } else {
      let sessionIsSXNU = sessionStorage.getItem('isSXNU');
      if (sessionIsSXNU) {
        setIsSXNU(sessionIsSXNU);
      } else {
        setIsSXNU(false);
      }
    }
  }, [localtion]);

  return { isSXNU };
};

export default useSXNU;
